/* STENCIL IMPORTS */
import { h } from "@stencil/core";
/*A function that helps highlighting characters when searching.*/
export const escapeRegExp = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};
export const hiChar = function (text, filterValue) {
    if (text && filterValue) {
        /* this function highlights the character(s) that match(es) the filter value. (hi)light (Char)acters */
        const escapedFilterValue = escapeRegExp(filterValue);
        const re = new RegExp(escapedFilterValue, "gi");
        return (h("span", { innerHTML: text.replace(re, '<span class="hiChar">$&</span>') }));
    }
    else {
        return text;
    }
};
//# sourceMappingURL=hiChar.js.map
